var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "136",
        viewBox: "0 0 178 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M177.144 0H0V136H177.144V0Z", fill: "#38CDFD" },
      }),
      _c("path", { attrs: { d: "M0 0H177.144V136L0 0Z", fill: "#4DF4FF" } }),
      _c("path", {
        attrs: {
          d: "M177.147 62.5216V0H95.7124L177.147 62.5216Z",
          fill: "#38CDFD",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }